<template>

    <div>
        <div class="wrapper">
            <div class='range-slider'>
                <input type="range" :min="priceRangeInitial.min" :max="priceRangeInitial.max" step="1"
                       v-model="sliderMin">
                <input type="number" min="0" max="180" step="1" :value="sliderMin"
                       @change="minAngle=$event.target.value">
                <input type="range" :min="priceRangeInitial.min" :max="priceRangeInitial.max" step="1"
                       v-model="sliderMax">
                <input type="number" min="0" max="180" step="1" :value="sliderMax"
                       @change="maxAngle=$event.target.value">
            </div>
            <button @click="rangeChange"><i class="fa fa-check-circle"></i></button>
        </div>
        <!--        <p><span v-text="sliderMin"></span>-<span v-text="sliderMax"></span></p>-->
    </div>

</template>

<script>
    export default {
        name: "PriceRange",
        props: ['priceRangeInitial', 'priceRangeCurrent',],
        data() {
            return {
                minAngle: 0,
                maxAngle: 99999
            }
        },
        created() {
        },
        mounted() {
            this.$watch('priceRangeCurrent', () => {
                this.minAngle = this.priceRangeCurrent.min;
                this.maxAngle = this.priceRangeCurrent.max;
            }, {immediate: true})
            this.minAngle = this.priceRangeCurrent.min;
            this.maxAngle = this.priceRangeCurrent.max;
        },
        methods: {
            rangeChange() {
                this.$emit('rangeChange', {min: this.minAngle, max: this.maxAngle})
            },
        },
        computed: {
            sliderMin: {
                get: function () {
                    var val = parseInt(this.minAngle);
                    return val;
                },
                set: function (val) {
                    val = parseInt(val);
                    if (val > this.maxAngle) {
                        this.maxAngle = val;
                    }
                    this.minAngle = val;
                }
            },
            sliderMax: {
                get: function () {
                    var val = parseInt(this.maxAngle);
                    return val;
                },
                set: function (val) {
                    val = parseInt(val);
                    if (val < this.minAngle) {
                        this.minAngle = val;
                    }
                    this.maxAngle = val;
                }
            },
        },
    }
</script>

<style scoped>
    .wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    button {
        color: #2497e3;
        font-size: 2em;
        border: none;
        outline: none;

        padding-left: 5px;
        padding-right: 5px;
        border-radius: 50%;
    }

    button:hover {
        box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.1);
    }

    button:focus {
        box-shadow: none;
    }

    .range-slider {
        /*width: 300px;*/
        width: 80%;
        /*margin: auto;*/
        text-align: center;
        position: relative;
        /*height: 6em;*/
    }

    .range-slider input[type=range] {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    input[type=number] {
        border: 1px solid #ddd;
        text-align: center;
        /*font-size: 1.6em;*/
        width: 40%;
        -moz-appearance: textfield;
    }

    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    input[type=number]:invalid,
    input[type=number]:out-of-range {
        /*border: 2px solid #ff6347;*/
        margin-bottom: 1rem;
    }

    input[type=range] {
        -webkit-appearance: none;
        width: 100%;
    }

    input[type=range]:focus {
        outline: none;
    }

    input[type=range]:focus::-webkit-slider-runnable-track {
        background: #2497e3;
    }

    input[type=range]:focus::-ms-fill-lower {
        background: #2497e3;
    }

    input[type=range]:focus::-ms-fill-upper {
        background: #2497e3;
    }

    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 5px;
        cursor: pointer;
        animate: 0.2s;
        background: #2497e3;
        border-radius: 1px;
        box-shadow: none;
        border: 0;
    }

    input[type=range]::-webkit-slider-thumb {
        z-index: 2;
        position: relative;
        box-shadow: 0px 0px 0px #000;
        border: 1px solid #2497e3;
        height: 18px;
        width: 18px;
        border-radius: 25px;
        background: #a1d0ff;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -7px;
    }

</style>